import { makeGqlQuery } from '@/utilities/gqlQuery';
import { gql } from '@/utilities/gql';
import { NARRATIVE_FRAGMENT } from './narrativeFragment';
import { ResolvedQueryData } from '@/utilities/genericTypes';
import { NARRATIVE_URL_COMPANY_FRAGMENT } from '../../utils/getNarrativeUrl';
import { NARRATIVE_SIDEBAR_COMPANY_FRAGMENT } from '../../components/NarrativeSidebar/NarrativeSidebar';

const QUERY = gql(
  `
 query Narrative($slug: String!) {
    Narrative(slug: $slug) {
      commentKey
      ...NarrativeFields
      company {
        ...NarrativeSidebarCompanyFields
        ...NarrativeUrlCompanyFields
      }
    }
  }
`,
  [
    NARRATIVE_FRAGMENT,
    NARRATIVE_SIDEBAR_COMPANY_FRAGMENT,
    NARRATIVE_URL_COMPANY_FRAGMENT,
  ]
);

export const useNarrative = makeGqlQuery(QUERY, {
  staleTime: 3600000,
});

export type Narrative = ResolvedQueryData<typeof useNarrative>['Narrative'];
